import theme from '@adsk/alloy-react-theme';

export const titleStyle = {
  display: 'flex',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.colors.charcoal300}`,
  paddingBottom: '0',
  paddingTop: '32px',
};

export const titleTextStyle = {
  ...theme.typography.bodyLarge,
  fontWeight: '600',
  margin: '0 9px 8px 0',
};

export const iconStyle = {
  width: '13px',
  height: '13px',
  marginBottom: '4px',
  color: theme.colors.charcoal600,
};

export const progressRingStyle = {
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '20px',
};

export const dropdownLabelStyle = {
  ...theme.typography.labelSmall,
  color: theme.colors.charcoal700,
  paddingBottom: '8px',
};

export const emptyMessageStyle = {
  ...theme.typography.bodyMedium,
  color: theme.colors.charcoal900,
  paddingTop: '16px',
  textAlign: 'center',
};

export const noSubscriptionMessageStyle = {
  ...theme.typography.heading2,
  color: theme.colors.charcoal900,
  paddingTop: '48px',
  textAlign: 'center',
};

export const warningBannerStyle = {
  ...theme.typography.bodyMedium,
  marginTop: '8px',
};
